import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function TempCostTimelineChart({ data, correlation }) {
  // Deduplicate data by hour - only keep one entry per hour
  const hourMap = {};
  data.forEach(item => {
    // Always prefer actuals rows if available for a given hour
    if (!hourMap[item.hour]) {
      hourMap[item.hour] = item;
    } else if (item.actuals != null && (hourMap[item.hour].actuals == null)) {
      hourMap[item.hour] = item;
    }
  });

  const deduplicatedData = Object.values(hourMap);
  const sorted = [...deduplicatedData].sort((a, b) => a.hour - b.hour);
  // Debug: log sorted data
  if (typeof window !== 'undefined' && window.localStorage) {
    window.lastTimelineChartData = sorted;
  }
  
  return (
    <div>
      <h2>Temperature and Actual by Hour</h2>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={sorted}>
          <XAxis 
            dataKey="hour" 
            ticks={[1, 4, 8, 12, 16, 20, 24]}
            tickFormatter={(hour) => `${hour}`}
          />
          <YAxis yAxisId="left" label={{ value: 'Actuals', angle: -90, position: 'insideLeft' }} />
          <YAxis yAxisId="right" orientation="right" label={{ value: 'Temperature (°F)', angle: 90, position: 'insideRight' }} />
          <Tooltip content={({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  const isDark = document.body.classList.contains('dark-mode');
  return (
    <div
      style={{
        background: isDark ? '#23272a' : '#fff',
        color: isDark ? '#fff' : '#222',
        border: '1px solid ' + (isDark ? '#444' : '#ccc'),
        borderRadius: 6,
        padding: 10,
        fontSize: 14,
        boxShadow: isDark ? '0 2px 8px #111' : '0 2px 8px #ccc',
        minWidth: 120
      }}
    >
      <div style={{ marginBottom: 4, fontWeight: 600 }}>Hour: {label}</div>
      {payload.map((entry, idx) => (
        <div key={idx} style={{ color: entry.color, fontWeight: 500 }}>
          {entry.name}: <b>{entry.value}</b>
        </div>
      ))}
    </div>
  );
}} />
          <Legend />
          <Line 
  yAxisId="left" 
  type="monotone" 
  dataKey="actuals" 
  name="Actuals" 
  stroke={document.body.classList.contains('dark-mode') ? '#fff' : '#8884d8'} 
/>
          <Line yAxisId="right" type="monotone" dataKey="temperature" name="Temperature" stroke="#e91e63" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
